import { render, staticRenderFns } from "./festivalModel.vue?vue&type=template&id=3e08deae&scoped=true&"
import script from "./festivalModel.vue?vue&type=script&lang=js&"
export * from "./festivalModel.vue?vue&type=script&lang=js&"
import style0 from "./festivalModel.vue?vue&type=style&index=0&id=3e08deae&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e08deae",
  null
  
)

export default component.exports